module.exports = __webpack_public_path__ + "assets/upreach-logo-white.png";


//////////////////
// WEBPACK FOOTER
// ./images/upreach-logo-white.png
// module id = 710
// module chunks = 0